// Copyright (c) 2020 Deere & Company

import actions from '../../actions-list';

export const updateSelectedMachinePutBack = data => ({
    data,
    type: actions.UPDATE_STATUS_CHANGE_SELECTED_MACHINE_PUT_BACK
});



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/update-selected-machine-put-back.js